export const TIMEZONE_TYPE = {
  UTC: 'UTC',
  KST: 'KST',
  EST: 'EST',
  PST: 'PST',
  CET: 'CET'
};

export const TIMEZONE = {
  [TIMEZONE_TYPE.UTC]: 'UTC',
  [TIMEZONE_TYPE.KST]: 'Asia/Seoul',
  [TIMEZONE_TYPE.EST]: 'America/New_York',
  [TIMEZONE_TYPE.PST]: 'America/Los_Angeles',
  [TIMEZONE_TYPE.CET]: 'CET'
};

export const DATE_INTL_TYPE = ['year', 'month', 'day', 'hour', 'minute', 'dayPeriod', 'weekday', 'second']; // TODO. seconds 는 테스트 후 지우기

export const UI_TYPE = {
  BTN_LAYER: 'btn_layer',
  LAYER_ONLY: 'layer_only',
  CONTENT_ONLY: 'content_only'
};

export const defaultConfig = {
  serverTime: new Date().toISOString(), // serverTime이 있으면 사용 (serverTime은 UTC)
  uiType: UI_TYPE.BTN_LAYER, // ui 타입 (버튼+레이어, 레이어만, 콘텐츠만)
  useSyncUpdate: true, // 1분씩 시간 업데이트 사용 여부
  usePreventDuplicate: false, // 중복 생성 방지 (react/vue 등 프레임워크에서 사용 시 중복 생성 방지하기 위해)
  btnName: '버튼명',
  timezoneArr: [ // 노출할 시간 데이터 배열
    {
      timezone: 'UTC', 
      useTimeDiff: true, // 기준 시간 비교값 노출 여부
      useTimeSelect: true, // select 제공 여부
    },
    {
      timezone: 'KST', 
      useTimeDiff: true, // 기준 시간 비교값 노출 여부
      useTimeSelect: true, // select 제공 여부
    },
    {
      timezone: 'PST', 
      useTimeDiff: true, // 기준 시간 비교값 노출 여부
      useTimeSelect: true, // select 제공 여부
    },
    {
      timezone: 'CET', 
      useTimeDiff: true, // 기준 시간 비교값 노출 여부
      useTimeSelect: true, // select 제공 여부
    },
    {
      timezone: 'EST', 
      useTimeDiff: true, // 기준 시간 비교값 노출 여부
      useTimeSelect: true, // select 제공 여부
    }
  ],
};